export default "__VITE_ASSET__DZ27Nhi1__"